import { REGISTER_SUCCESS, REGISTER_FAIL, USER_LOADED, AUTH_ERROR, UTENTE_ERROR, LOGIN_SUCCESS, LOGIN_FAIL, MODIFICA_PROFILO, GET_UTENTI, AGGIUNGI_UTENTE, GET_UTENTE, MODIFICA_UTENTE, LOGOUT } from '../actions/types';

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: false,
    loading: true,
    user: null,
    utenti: [],
    utente: null
}

export default function(state = initialState, action){
    const { type, payload } = action;

    switch(type){
        case USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload
            };
        case REGISTER_SUCCESS:
        case LOGIN_SUCCESS:
        case REGISTER_SUCCESS:
            localStorage.setItem('token', payload.token);
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false
            };
        case MODIFICA_PROFILO:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload
            };
        case GET_UTENTI:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                utenti: payload
            };
        case AGGIUNGI_UTENTE:
        case MODIFICA_UTENTE:
            let arrayUtenti = [...state.utenti];
            arrayUtenti.push(payload);
            arrayUtenti.sort((a,b) => (a.username.toLowerCase() > b.username.toLowerCase()) ? 1 : ((b.username.toLowerCase() > a.username.toLowerCase()) ? -1 : 0)); 
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                utenti: arrayUtenti
            };
        case GET_UTENTE:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                utente: payload
            };
        case UTENTE_ERROR:
            return {
                ...state,
                loading: false
            };
        case REGISTER_FAIL:
        case AUTH_ERROR:
        case LOGIN_FAIL:
        case LOGOUT:
            localStorage.removeItem('token');
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                user: null,
                utenti: [],
                loading: false,
                utente: null
            };
        default:
            return state;
    }
}